import { Firestore, collection, getDocs, limit, orderBy, query, where } from 'firebase/firestore';
import logger from './logger';

interface Session {
  id: string;
  userId: string;
  juggleCount: number;
  duration: number;
  date: Date;
  mode: 'manual' | 'ai';
  juggleRate: number;
}

/** Share overlapping requests only; each completed request is immediately evicted. */
export function createSessionReader(db: Firestore) {
  const pending = new Map<string, Promise<Session[]>>();
  return (userId: string, limitCount = 20): Promise<Session[]> => {
    const key = JSON.stringify([userId, limitCount]);
    const existing = pending.get(key);
    if (existing) return existing;
    const read = async (): Promise<Session[]> => {
      try {
        const snapshot = await getDocs(query(collection(db, 'sessions'),
          where('userId', '==', userId), orderBy('date', 'desc'), limit(limitCount)));
        return snapshot.docs.map(document => {
          const data = document.data();
          return {
            id: document.id, userId: data.userId, juggleCount: data.juggleCount || 0,
            duration: data.duration || 0, date: data.date?.toDate() || new Date(),
            mode: data.mode || 'manual', juggleRate: data.juggleRate || 0
          };
        });
      } catch (error) {
        logger.error('Error fetching user sessions:', error);
        return [];
      }
    };
    const result = read().then(sessions => { pending.delete(key); return sessions; });
    pending.set(key, result);
    return result;
  };
}
